import { render, staticRenderFns } from "./RoundTerm.vue?vue&type=template&id=456ea892&"
import script from "./RoundTerm.vue?vue&type=script&lang=js&"
export * from "./RoundTerm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports